module.exports = __webpack_public_path__ + "static/media/objects_21.daf15df9.svg";